(function () {
    'use strict';

    angular.module('servicesModule')
           .service('documentContentsSearchService', documentContentsSearchService);

    documentContentsSearchService.$inject = ['$timeout', '$sce'];

    function documentContentsSearchService($timeout, $sce) {
        var service = {
            searchAndHighlight: searchAndHighlight,
            searchAndHighlightText: searchAndHighlightText,
            navForward: navForward,
            navBackward: navBackward
        };

        return service;

        function searchAndHighlight(text, search) {
            if (text != null) {
                if ((search || angular.isNumber(search)) && text != '') {
                    text = htmlDecode(text.toString()).replaceHtmlEntites();
                    search = search.toString().replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1');

                    var re = '(' + search + ')(?!([^\<]+)?\>)',
                    regExp = new RegExp(re, 'gi'),
                    sTag = "<span class='ui-match'>",
                    eTag = "</span>";
                    var textHighLight = text.replace(regExp, sTag + '$1' + eTag);
                    return $sce.trustAsHtml(textHighLight.returnWhitespace());
                } else {
                    return $sce.trustAsHtml(text.toString());
                }
            }
        };

        function searchAndHighlightText(model) {
            $timeout(function () {
                model.totalFound = angular.element(".ui-match").length;
                model.currentIndex = model.totalFound > 0 ? 1 : 0;
                var searchNavigator = angular.element("#search-navigator");
                if (searchNavigator.hasClass('display--non')) {
                    searchNavigator.removeClass('display--non');
                }
                if (model.totalFound > 0) {
                    angular.element(".ui-match")[0].className += ' match-focus';
                    angular.element(".ui-match")[0].id = 'highlight';;
                }
            });
        };

        function navForward(model) {
            if (model.totalFound > 0) {
                if (model.currentIndex == model.totalFound) {
                    model.currentIndex = 1;
                    clearHighlight(angular.element(".ui-match")[model.totalFound - 1], model);
                    addHighlight(angular.element(".ui-match")[model.currentIndex - 1], model);
                } else {
                    model.currentIndex += 1;
                    var index = model.currentIndex
                    clearHighlight(angular.element(".ui-match")[index - 2], model);
                    addHighlight(angular.element(".ui-match")[index - 1], model);
                }
                scrollToMatch();
            }
        };

        function navBackward(model) {
            if (model.totalFound > 0) {
                if (model.currentIndex == 1) {
                    model.currentIndex = model.totalFound;
                    clearHighlight(angular.element(".ui-match")[0], model);
                    addHighlight(angular.element(".ui-match")[model.currentIndex - 1], model);
                }
                else {
                    model.currentIndex -= 1;
                    var index = model.currentIndex;
                    clearHighlight(angular.element(".ui-match")[index], model);
                    addHighlight(angular.element(".ui-match")[index - 1], model);
                }
                scrollToMatch();
            }
        };

        function scrollToMatch() {
            var element = angular.element('#highlight');
            var offsetTop = element.offset().top;
            //var $parentDiv = $('#' + documentContent.content + '');
			var $parentDiv = $('.document-detail');
            var visibleAreaStart = $parentDiv.offset().top;
            $parentDiv.animate({
                scrollTop: $parentDiv.scrollTop() - visibleAreaStart + offsetTop - 50
            }, 100);
        };

        function clearHighlight(element, model) {
            if (element != undefined) {
                element.className = 'ui-match';
                element.id = '';
            } else {
                clearSearchPanel(model);
            }
        };

        function addHighlight(element, model) {
            if (element != undefined) {
                element.className += ' match-focus';
                element.id = 'highlight';
            } else {
                clearSearchPanel(model);
            }
        };

        function clearSearchPanel(model) {
            model.highlightText = '';
            model.currentIndex = 0;
            model.totalFound = 0;
        };

        function htmlDecode(value) {
            var dynamicDiv = document.createElement("div");
            dynamicDiv.innerHTML = value;
            return dynamicDiv.innerHTML;
        }
    };

    String.prototype.replaceHtmlEntites = function () {
        var s = this;
        var translate_re = /&(nbsp|amp|quot|lt|gt);/g;
        var translate = { "nbsp": "𠮷", "amp": "&", "quot": "\"", "lt": "<", "gt": ">" };
        return (s.replace(translate_re, function (match, entity) {
            return translate[entity];
        }));
    };

    String.prototype.returnWhitespace = function () {
        var s = this;
        var reg = new RegExp("𠮷", "gm");
        return (s.replace(reg, "&nbsp;"));
    };

})();